import ProfileAvatar from '../components/ProfileAvatar';
import { getUsersProfile } from '../../../api/users';
import AddProfile from '../components/AddProfile';

export default function (page) {
  return getUsersProfile().then(({ data }) => {
    const { profiles } = data.user;
    const items = profiles.map((profile, index) => ({
      collision: true,
      type: ProfileAvatar,
      w: 254,
      h: 254,
      index,
      src: profile.avatar?.url,
      title: profile.first_name ?? '',
      subscription: data?.user?.active?.status,
      data: {
        id: profile.id,
        autoplay: profile.autoplay,
        native_language: profile?.language || 'en-US',
      },
    }));

    profiles.length < 5 &&
      items.push({
        index: profiles.length,
        collision: true,
        type: AddProfile,
        w: 254,
        h: 254,
        src: 'images/my-list.svg',
        title: 'Add Profile',
        data: {
          id: 0,
        },
      });

    page._Profiles.items = items;
  });
}
